"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactSensitiveValuesInText = exports.isSensitiveKey = exports.SENSITIVE_KEYS_IN_LOWER_CASE = exports.REDACTED_VALUE = void 0;
exports.REDACTED_VALUE = '******';
exports.SENSITIVE_KEYS_IN_LOWER_CASE = new Set([
    '_applicationid',
    '_javascriptkey',
    '_masterkey',
    '_sessiontoken',
    'api-token',
    'api_key',
    'apikey',
    'authorization',
    'authorizer',
    'cookie',
    'esante-api-key',
    'ocp-apim-subscription-key',
    'password',
    'newpassword',
    'currentpassword',
    'session-token',
    'sessiontoken',
    'token',
    'webhooksecret',
    'x-api-key',
    'x-api-token',
    'x-delegate-token',
    'x-insee-api-key-integration',
    'x-iziwork-api-gateway-token',
    'x-parse-application-id',
    'x-parse-client-key',
    'x-parse-javascript-key',
    'x-parse-master-key',
    'x-parse-rest-api-key',
    'x-parse-session-token',
    'x-reviewapp-api-token',
    'x-signer-access-token',
    'x-signing-tokens',
]);
const isSensitiveKey = (key) => exports.SENSITIVE_KEYS_IN_LOWER_CASE.has(key.toLowerCase());
exports.isSensitiveKey = isSensitiveKey;
const SENSITIVE_KEYS_PATTERN = [...exports.SENSITIVE_KEYS_IN_LOWER_CASE]
    .map(key => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');
const JSON_STRING_VALUE_OF_SENSITIVE_KEY = new RegExp(`("(?:${SENSITIVE_KEYS_PATTERN})"\\s*:\\s*)"(?:[^"\\\\]|\\\\[\\s\\S]?)*(?:"|$)`, 'gi');
const QUERY_VALUE_OF_SENSITIVE_KEY = new RegExp(`((?:^|[?&])(?:${SENSITIVE_KEYS_PATTERN})=)[^&#\\s"']*`, 'gi');
const PASSWORD_IN_URL = /(\b[a-z][a-z\d+.-]{0,31}:\/\/[^\s:/?#@"<>]*:)[^\s/?#"<>]+@/gi;
const redactSensitiveValuesInText = (text) => text
    .replace(JSON_STRING_VALUE_OF_SENSITIVE_KEY, `$1"${exports.REDACTED_VALUE}"`)
    .replace(QUERY_VALUE_OF_SENSITIVE_KEY, `$1${exports.REDACTED_VALUE}`)
    .replace(PASSWORD_IN_URL, `$1${exports.REDACTED_VALUE}@`);
exports.redactSensitiveValuesInText = redactSensitiveValuesInText;
